export const FONT_PRIMARY = '#141414';
export const FONT_SECONDARY = '#757575';
export const FONT_DISABLED = '#9e9e9e';
export const BACKGROUND = '#ffffff';
export const ROW_SELECTED = '#e0e0e0';
export const BORDER = '#a0a8ae';
